import { useStaticQuery, graphql } from 'gatsby'

export const useCouponSectionQuery = () => {
  const { wpPage } = useStaticQuery(graphql`
    query CouponSectionQuery {
      wpPage(title: { eq: "Home" }) {
        todaysSpecials {
          todaysSpecials {
            backgroundImageMobile {
              localFile {
                childImageSharp {
                  gatsbyImageData(layout: FULL_WIDTH, quality: 100, formats: [WEBP])
                }
              }
            }
            backgroundImageDesktop {
              localFile {
                childImageSharp {
                  gatsbyImageData(layout: FULL_WIDTH, quality: 100, formats: [WEBP])
                }
              }
            }
            title1
            subtitle1
            title2
            subtitle2
            link {
              title
              url
            }
            couponLogo {
              localFile {
                childImageSharp {
                  gatsbyImageData(formats: WEBP, sizes: "(min-width: 1024px) 14vw, 43vw")
                }
              }
            }
            couponLogoAltText
            coupons {
              text
            }
            couponDescriptionText
            printButtonText
          }
        }
      }
    }
  `)
  return wpPage.todaysSpecials.todaysSpecials
}
